"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Skeleton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const colors_1 = require("../../common/colors");
const DURATION = 750;
const SHIRIMING_DELAY = 2000;
const AnimatedLinearGradient = react_native_1.Animated.createAnimatedComponent(react_native_linear_gradient_1.default);
function Skeleton({ style }) {
    const { current: animation } = (0, react_1.useRef)(new react_native_1.Animated.Value(-1));
    const { current: animatedPosition } = (0, react_1.useRef)(animation.interpolate({
        inputRange: [-1, 1],
        outputRange: ["-51.63%", "100%"]
    }));
    const wasUnmountedRef = (0, react_1.useRef)(false);
    const animationCounter = (0, react_1.useRef)(0);
    const startAnimation = (0, react_1.useCallback)(() => {
        react_native_1.Animated.timing(animation, {
            duration: 0,
            toValue: -1,
            useNativeDriver: true,
        }).start();
        react_native_1.Animated.timing(animation, {
            duration: DURATION,
            toValue: 1,
            useNativeDriver: true,
        }).start((e) => {
            animationCounter.current = animationCounter.current % 2 === 0 ? 1 : 0;
            if (e.finished && !wasUnmountedRef.current) {
                setTimeout(() => {
                    startAnimation();
                }, animationCounter.current === 0 ? SHIRIMING_DELAY : 0);
            }
        });
    }, []);
    (0, react_1.useEffect)(() => {
        wasUnmountedRef.current = false;
        startAnimation();
        return () => { wasUnmountedRef.current = true; };
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.background, style], children: (0, jsx_runtime_1.jsx)(AnimatedLinearGradient, { colors: [colors_1.Colors.DARK_500, '#2F2F32'], style: [styles.shine, {
                    left: animatedPosition,
                }] }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    background: {
        backgroundColor: colors_1.Colors.DARK_500,
        overflow: "hidden"
    },
    shine: {
        width: '51.63%',
        height: '100%',
        position: 'absolute',
    },
});
